<!--
* 组件名 : 受迫害人物
* 开发者 : JY
*
* 参数:
*  name             { string }    - 人物名称
*  description      { string }    - 受迫害描述
*  poster           { string }    - 人物头像
*
* 事件:  null
*
*
-->
<template>
  <div class="v-person-info">
    <div class="person-item" @click="on_open_modal">
      <div class="avatar">
        <img :src="avatar" />
      </div>

      <div class="name-info">
        <p class="name">{{ name }}</p>
        <p class="age-inter"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/utils/util";
export default {
  name: "person-info",
  props: {
    name: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    poster: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      avatar: i18n(
        `images/spread-of-kingdom-gospel/${this.$route.name}/person/${this.poster}|useWebp=false`
      ),
    };
  },
  methods: {
    //  开启信息弹框
    on_open_modal() {
      this.$personInfoModal({
        name: this.name,
        desc: this.description,
        poster: this.avatar,
      });
      document.body.classList.add("disabled-scroll");
    },
  },
};
</script>

<style lang="scss">
.v-person-info {
  width: 212px;
  padding: 0 28px;
  margin-top: 48px;

  .person-item {
    cursor: pointer;
  }

  .avatar {
    width: 100%;
    padding-top: 140%;
    position: relative;
  }

  img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .name-info {
    margin-top: 16px;

    p {
      text-align: center;
      color: $color-white;
    }
  }

  @media (max-width: $lx-min) {
    width: 180px;
    padding: 0 24px;
  }
}
</style>
